import React, { useState } from "react";
import { Dialog, FormSelect } from "@actinc/dls/components";
import { ImagePlus as ImagePlusIcon } from "@actinc/dls/icons";
import {
  Card,
  CardContent,
  CardHeader,
  DialogContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";

const InsertImageDialog = ({ editor, images = [], onClose, open = false }) => {
  const [align, setAlign] = useState("middle");
  const alignmentOptions = [
    {
      label: "Top",
      value: "top",
    },
    {
      label: "Middle",
      value: "middle",
    },
    {
      label: "Bottom",
      value: "bottom",
    },
  ];
  const byTimestamp = (a, b) => {
    return (
      b.fileTimestamp - a.fileTimestamp ||
      getTimestampFromFilename(b.name) - getTimestampFromFilename(a.name)
    );
  };
  const getTimestampFromFilename = (name) =>
    parseInt(
      name.replace(
        /\w*_(\d{8})_(\d{6})\.\w{3}$/,
        (_match, p1, p2) => `${p1}${p2}`,
      ),
    ) || 0;
  const insertImage =
    ({ src }) =>
    () => {
      editor.execute("insertImage", {
        source: [
          { htmlAttributes: { styles: { "vertical-align": align } }, src },
        ],
      });
      onClose();
    };

  return (
    <Dialog maxWidth="md" onClose={onClose} open={open} title="Insert Image">
      <DialogContent dividers={true}>
        <FormSelect
          formControlProps={{
            margin: "none",
            size: "small",
            sx: {
              marginBottom: 2,
              "& .MuiInputBase-root": {
                marginTop: 0,
              },
            },
          }}
          fullWidth={true}
          id={`vertical-align`}
          label={"Alignment"}
          name={`vertical-align`}
          onChange={(e) => {
            setAlign(e.target.value);
          }}
          options={alignmentOptions}
          placeholderIsDisabled={true}
          required={true}
          value={align}
          variant="standard"
        />
        <Grid container spacing={3}>
          {images.sort(byTimestamp).map((image) => (
            <Grid item key={image.name} xs>
              <Card raised={true}>
                <CardHeader
                  action={
                    <IconButton
                      aria-label={`Insert ${image.name} into content`}
                      onClick={insertImage(image)}
                      size="large"
                    >
                      <ImagePlusIcon />
                    </IconButton>
                  }
                  subheader={
                    <Typography
                      noWrap={!/\s/.test(image.identifier)}
                      sx={{ maxWidth: "50em" }}
                      variant="body2"
                    >
                      {image.identifier || ""}
                    </Typography>
                  }
                  title={image.name}
                />
                <CardContent>
                  <img src={image.src} alt={image.altText} />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export { InsertImageDialog };
